export const IsEditing = ({ event, isEditing }) => {
  if (!isEditing) return null;
  return (
    <div className="border-t border-slate-200 mt-4 pt-4 text-sm font-medium text-slate-700">
      Registered Athletes: {event?.totalRegisteredAthletes ?? 0}
    </div>
  );
};
